import { render } from "./ChooseCoupons.vue?vue&type=template&id=d1628a5e&scoped=true"
import script from "./ChooseCoupons.vue?vue&type=script&lang=js"
export * from "./ChooseCoupons.vue?vue&type=script&lang=js"

import "./ChooseCoupons.vue?vue&type=style&index=0&id=d1628a5e&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1628a5e"]])

export default __exports__